export const front = `
## pibox TFLITE
import os
import argparse
import cv2
import numpy as np
import sys
import time
from threading import Thread
import importlib.util

## 출력을 위한 import
import RPi.GPIO as GPIO
import pigpio
import time
import board
import neopixel

`;

export const middle = `
# 카메라 오브젝트
class VideoStream:
    def __init__(self,resolution=(320,240),framerate=3): # 원래는 640,480 그리고 30 framerate
        # 파이 카메라를 시작합니다.
        self.stream = cv2.VideoCapture(0)
        ret = self.stream.set(cv2.CAP_PROP_FOURCC, cv2.VideoWriter_fourcc(*'MJPG'))
        ret = self.stream.set(3,resolution[0])
        ret = self.stream.set(4,resolution[1])
            
        # 첫번째 사진을 불러옵니다.
        (self.grabbed, self.frame) = self.stream.read()

	    # 멈출 수 있도록 stopped를 설정해줍니다.
        self.stopped = False

    def start(self):
	    # 비디오 스트림에서 프레임을 읽어오는 쓰레드를 시작합니다.
        Thread(target=self.update,args=()).start()
        return self

    def update(self):
        # 쓰레드가 멈출 때 까지 계속 스트림을 실행합니다.
        while True:
            # 카메라가 멈추면 스트림을 멈춥니다.
            if self.stopped:
                # 카메라 리소스를 닫습니다.
                self.stream.release()
                return

            # 멈춘것이 아니라면 프레임을 가져옵니다.
            (self.grabbed, self.frame) = self.stream.read()

    def read(self):
	    # 가장 최근 프레임을 가져옵니다.
        return self.frame

    def stop(self):
	    # 카메라 쓰레드를 정지합니다.
        self.stopped = True

# 입력 파라미터를 정의합니다.
parser = argparse.ArgumentParser()
parser.add_argument('--modeldir', help='Folder the .tflite file is located in',
                    required=True)
parser.add_argument('--graph', help='Name of the .tflite file, if different than model.tflite',
                    default='model.tflite')
parser.add_argument('--labels', help='Name of the labelmap file, if different than labels.txt',
                    default='labels.txt')
parser.add_argument('--threshold', help='Minimum confidence threshold for displaying detected objects',
                    default=0.5)
parser.add_argument('--resolution', help='Desired webcam resolution in WxH. If the webcam does not support the resolution entered, errors may occur.',
                    default='320x240') # 원래는 1280x720 속도를 위해 낮춤
parser.add_argument('--edgetpu', help='Use Coral Edge TPU Accelerator to speed up detection',
                    action='store_true',default=False)

args = parser.parse_args()

MODEL_NAME = args.modeldir
GRAPH_NAME = args.graph
LABELMAP_NAME = args.labels
min_conf_threshold = float(args.threshold)
resW, resH = args.resolution.split('x')
imW, imH = int(resW), int(resH) # 라즈베리파이 제로 + 파이카메라에서는 224,224 가 아주 쬐에에에끔 빠릅니다.
use_TPU = args.edgetpu

# 텐서플로우 라이브러리를 가져옵니다.
# 텐서플로우 라이브러리가 없다면, tflite_runtime 을 가져옵니다.
# 코랄 TPU를 사용한다면, TPU 용 라이브러리를 가져옵니다. (import the load_delegate library)
pkg = importlib.util.find_spec('tensorflow')
if pkg is None:
    from tflite_runtime.interpreter import Interpreter
    if use_TPU:
        from tflite_runtime.interpreter import load_delegate
else:
    from tensorflow.lite.python.interpreter import Interpreter
    if use_TPU:
        from tensorflow.lite.python.interpreter import load_delegate

# TPU를 사용한다면 TPU 모델을 가져옵니다.
if use_TPU:
    # 'edgetpu.tflite'가 TPU를 사용할 때의 기본 경로입니다.
    if (GRAPH_NAME == 'model.tflite'):
        GRAPH_NAME = 'edgetpu.tflite'       

# 작업 경로와 현재 경로를 일치시킵니다.
CWD_PATH = os.getcwd()

# 모델 경로를 설정합니다.
PATH_TO_CKPT = os.path.join(CWD_PATH,MODEL_NAME,GRAPH_NAME)

# 라벨 경로를 설정합니다.
PATH_TO_LABELS = os.path.join(CWD_PATH,MODEL_NAME,LABELMAP_NAME)

# 라벨을 가져옵니다.
with open(PATH_TO_LABELS, 'r') as f:
    labels = [line.strip() for line in f.readlines()]

# 첫번째 라벨이 ??? 인 경우가 있어 그럴 경우 제거합니다.
if labels[0] == '???':
    del(labels[0])

# 텐서플로우 모델을 가져옵니다. TPU를 쓸 경우 TPU 모델로 가져옵니다.
if use_TPU:
    interpreter = Interpreter(model_path=PATH_TO_CKPT,
                              experimental_delegates=[load_delegate('libedgetpu.so.1.0')])
    print(PATH_TO_CKPT)
else:
    interpreter = Interpreter(model_path=PATH_TO_CKPT)

interpreter.allocate_tensors()

# 로드된 모델의 정보를 가져옵니다.
input_details = interpreter.get_input_details()
output_details = interpreter.get_output_details()
height = input_details[0]['shape'][1]
width = input_details[0]['shape'][2]
#print("가로")
#print(width)
#print("세로")
#print(height)
# 입력이 소수인지 아닌지 판단합니다.
floating_model = (input_details[0]['dtype'] == np.float32)

input_mean = 127.5
input_std = 127.5

# 연산 프레임을 체크하기 위한 변수를 할당합니다.
frame_rate_calc = 1
freq = cv2.getTickFrequency()

# 상단에서 정의한 비디오 스트림을 시작합니다.
videostream = VideoStream(resolution=(imW,imH),framerate=30).start() 
time.sleep(1)

# 프레임으로 연산을 시작합니다.
while True:

    # 연산 프레임을 위한 시간 체크 변수를 할당합니다.
    t1 = cv2.getTickCount()

    # 비디오스트림에서 프레임을 읽어옵니다.
    frame1 = videostream.read()

    # 입력에 넣을 수 있도록 해상도를 변경합니다.
    frame = frame1.copy()
    frame_rgb = cv2.cvtColor(frame, cv2.COLOR_BGR2RGB)
    # 위에서 input을 224,224로 설정했다면 아래 줄은 넘어가도 됩니다..
    frame_resized = cv2.resize(frame_rgb, (width, height)) 
    input_data = np.expand_dims(frame_resized, axis=0)

    # 입력이 소수라면 소수로 바꿔줍니다.
    if floating_model:
        input_data = (np.float32(input_data) - input_mean) / input_std

    # 로드된 모델에 입력을 넣어 결과를 가져옵니다.
    interpreter.set_tensor(input_details[0]['index'],input_data)
    interpreter.invoke()
    result=interpreter.get_tensor(output_details[0]['index'])[0]
    print(labels[np.argmax(result)])
    #print(result)
    # 초당 연산 프레임을 계산합니다.
    t2 = cv2.getTickCount()
    time1 = (t2-t1)/freq
    frame_rate_calc= 1/time1
    #print(frame_rate_calc)
`;
